import { paymentDirectionMap } from "features/Payments/constants/payment.constants";
import { Payment } from "features/Payments/types/payment.types";
import { formatCurrency } from "utils/currency";

const PaymentAmountBadge = ({ record }: { record: Payment | null }) => {
  if (!record) {
    return <span className="text-muted">—</span>;
  }

  const directionMeta = paymentDirectionMap[record.direction];
  const title = directionMeta
    ? `${directionMeta.label}: ${directionMeta.hint}`
    : undefined;

  return (
    <div className="d-flex flex-column align-items-start lh-sm">
      <span
        className={`text-${directionMeta?.color} fw-semibold tabular-nums`}
        title={title}
      >
        {directionMeta?.sign} {formatCurrency(record.amount)}
      </span>
      {directionMeta ? (
        <small className="text-muted">{directionMeta.label}</small>
      ) : null}
    </div>
  );
};

export default PaymentAmountBadge;
